<template>
  <div class="container">
    <div class="center" v-if="state != 3">
      <div style="margin-bottom: 0.1rem" class="centerBox">
        <p>资源名称</p>
        <el-input
          style="width: 1.7rem; margin-right: 0.1rem"
          size="small"
          v-model="input"
          placeholder="资源名称"
        ></el-input>
        <p>提问人身份</p>
        <el-select
          style="width: 1.7rem; margin-right: 0.1rem"
          size="small"
          v-model="value"
          placeholder="请选择"
        >
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
        <p>提问人昵称</p>
        <el-input
          style="width: 1.7rem; margin-right: 0.1rem"
          size="small"
          v-model="input"
          placeholder="提问人昵称"
        ></el-input>
        <p>问题关键字</p>
        <el-input
          style="width: 1.7rem; margin-right: 0.1rem"
          size="small"
          v-model="input"
          placeholder="问题关键字"
        >
        </el-input>
        <el-button style="color: #fff; background-color: #e69c37" size="small"
          >搜索</el-button
        >
        <el-button size="small">重置</el-button>
      </div>
      <div class="centerBox">
        <p>提问日期</p>
        <el-date-picker
          style="margin-right: 0.1rem"
          size="small"
          v-model="value"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        >
        </el-date-picker>
      </div>
    </div>
    <div v-else class="center">
      <div class="centerBox">
        <p>资源名称</p>
        <el-input
          style="width: 1.7rem; margin-right: 0.1rem"
          size="small"
          v-model="input"
          placeholder="资源名称"
        ></el-input>
        <p>问题关键字</p>
        <el-input
          style="width: 1.7rem; margin-right: 0.1rem"
          size="small"
          v-model="input"
          placeholder="问题关键字"
        >
        </el-input>
        <p>提问日期</p>
        <el-date-picker
          style="margin-right: 0.1rem"
          size="small"
          v-model="value"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        >
        </el-date-picker>
        <el-button style="color: #fff; background-color: #e69c37" size="small"
          >搜索</el-button
        >
        <el-button size="small">重置</el-button>
      </div>
    </div>
    <footer class="footer">
      <el-radio-group v-model="radio2" size="small">
        <el-radio-button
          v-for="item in radio2List[state]"
          :key="item"
          :label="item"
        ></el-radio-button>
      </el-radio-group>
    </footer>
    <el-table
      :data="tableData"
      :header-cell-style="{ color: '#000' }"
      @selection-change="handleSelectionChange"
      style="width: 100%"
    >
      <el-table-column align="center" type="selection" width="55"> </el-table-column>
      <el-table-column align="center" prop="date" label="资源类型"> </el-table-column>
      <el-table-column align="center" prop="date" label="资源名称"> </el-table-column>
      <div v-if="state != 3">
        <el-table-column align="center" prop="date" label="提问人身份"> </el-table-column>
        <el-table-column align="center" prop="date" label="提问人ID"> </el-table-column>
        <el-table-column align="center" prop="date" label="提问人昵称"> </el-table-column>
      </div>
      <el-table-column align="center" width="300" prop="date" label="提问时间"> </el-table-column>
      <el-table-column align="center" prop="date" label="问题"> </el-table-column>
      <div v-if="state == 3">
        <el-table-column align="center" prop="date" label="提问地点"> </el-table-column>
        <el-table-column align="center" prop="date" label="收到回复"> </el-table-column>
        <el-table-column align="center" prop="date" label="所获积分"> </el-table-column>
      </div>
      <div v-if="state == 2">
        <el-table-column align="center" prop="date" label="回答地点"> </el-table-column>
        <el-table-column align="center" prop="date" label="所获积分"> </el-table-column>
      </div>
      <el-table-column align="center" prop="date" label="操作"> </el-table-column>
    </el-table>
    <Pagination></Pagination>
  </div>
</template>

<script>
import Pagination from "@/components/Pagination.vue";

export default {
  components: {
    Pagination,
  },
  props: {
    state: {
      type: String,
      default: "1",
    },
    selsect: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      tableData: [{}],
      checkList: [],
      input: "",
      value: "",
      radio2: this.selsect,
      radio2List: {
        1: ["全部", "已回答", "未回答"],
        2: ["全部已回答"],
        3: ["全部我的提问"],
      },
      radio: "客户发起的评价",
      options: [
        {
          value: "1",
          label: "全部",
        },
        {
          value: "2",
          label: "定制师",
        },
        {
          value: "3",
          label: "同业",
        },
        {
          value: "4",
          label: "用户",
        },
        {
          value: "5",
          label: "分销",
        },
      ],
    };
  },
  computed: {},
  watch: {},
  methods: {
    handleSelectionChange() {},
  },
  created() {},
  mounted() {},
};
</script>
<style lang="scss" scoped>
.container {
  .center {
    padding: 0.2rem;
    background-color: #f1f1f1;
    margin-bottom: 0.2rem;
    p {
      margin-right: 0.1rem;
    }
    .centerBox {
      display: flex;
      align-items: center;
    }
  }
  .footer {
    display: flex;
    align-items: center;
    margin-bottom: 0.2rem;
  }
}
</style>
